import { isError, UnexpectedError } from "../errors/index.js";
import { TaggedError } from "../errors/tagged-error.js";
import { runUnsafe } from "../results/run-unsafe.js";
export class FileService {
    crypto;
    db;
    entitySchema;
    constructor(crypto, db, entitySchema) {
        this.crypto = crypto;
        this.db = db;
        this.entitySchema = entitySchema;
    }
    async store(file) {
        if (!this.isAcceptableMimeType(file.mimeType)) {
            return new InvalidFileTypeError();
        }
        const parsedFile = await this.parseFile(await runUnsafe(this.crypto.generateUUID()), file);
        if (isError(parsedFile)) {
            return parsedFile;
        }
        try {
            if (isError(parsedFile)) {
                return parsedFile;
            }
            await this.db.save(this.entitySchema, parsedFile);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (e) {
            await this.deleteFile(parsedFile.id);
            return new UnexpectedError(e.message);
        }
        return parsedFile;
    }
    async replace(id, file) {
        if (!this.isAcceptableMimeType(file.mimeType)) {
            return new InvalidFileTypeError();
        }
        const result = await this.remove(id);
        if (isError(result)) {
            return result;
        }
        return this.store(file);
    }
    async remove(id) {
        try {
            await this.deleteFile(id);
            await this.db.delete(this.entitySchema, id);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (e) {
            return new UnexpectedError(e.message);
        }
    }
}
export class InvalidFileTypeError extends TaggedError {
    constructor() {
        super("InvalidFileTypeError");
    }
}
